import { app_config } from "../config/app.config";
import toast from "react-hot-toast";

const errorMessageFormat = (message) => {
  if (!message) return "";
  let words = message.split("_");
  words = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));
  let formattedMessage = words.join(" ");
  return formattedMessage;
};

export const toastSuccessMessage = (message) => {
  toast.success(errorMessageFormat(message), app_config.toast_config);
};

export const toastErrorMessage = (message) => {
  toast.error(errorMessageFormat(message), app_config.toast_config);
};

export const scrollToSection = (sectionId, setActiveTab = () => {}) => {
  const element = document.getElementById(sectionId);
  if (element) {
    const navbarHeight = 80; // Approximate height of the fixed navbar
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - navbarHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
    setActiveTab(sectionId);
  }
};

export const getImageUrl = (imagePath, emptyPath = "/placeholder.png") => {
  if (!imagePath) return emptyPath;
  if (imagePath.startsWith('http') || imagePath.startsWith('https')) return imagePath;
  const IMG_PATH = process.env.REACT_APP_IMAGE_BASEURL || "";
  return IMG_PATH + imagePath;
};

export const getInitials = (name) => {
  if (!name) return "";

  const parts = name.trim().split(" ");

  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }

  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

export const stripHtml = (html) => {
  if (!html) return "";
  // Substitute block elements with spaces to prevent text joining
  const formattedHtml = html.replace(/<\/p>|<\/li>|<br\s*\/?>/gi, " ");
  const doc = new DOMParser().parseFromString(formattedHtml, "text/html");
  return (doc.body.textContent || "").trim().replace(/\s+/g, " ");
};